import { motion } from "framer-motion";

function Blob({ className, colors, delay = 0, duration = 6, path }) {
  return (
    <motion.div
      className={className}
      aria-hidden="true"
      animate={{ y: [0, -24, 0], rotate: [0, 8, 0] }}
      transition={{
        duration,
        delay,
        repeat: Infinity,
        ease: "easeInOut",
      }}
    >
      <svg viewBox="0 0 200 200" className="w-full h-full drop-shadow-[6px_6px_0_rgba(28,25,23,0.15)]">
        <path d={path} fill={colors} stroke="#1C1917" strokeWidth="3" />
      </svg>
    </motion.div>
  );
}

// Floating playful shapes used across sections
export function FloatingShapes() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      <Blob
        className="absolute -left-6 top-24 w-24 h-24 md:w-40 md:h-40"
        colors="#FCD34D"
        duration={7}
        path="M45,-58C58,-48,68,-34,71,-19C74,-4,70,13,62,27C54,41,42,52,27,60C12,68,-6,73,-23,68C-40,63,-56,48,-64,31C-72,14,-72,-6,-65,-22C-58,-38,-44,-50,-30,-59C-16,-68,-1,-74,13,-73C27,-72,54,-68,45,-58Z"
      />
      <Blob
        className="absolute right-4 top-40 w-16 h-16 md:w-28 md:h-28"
        colors="#8B5CF6"
        delay={1.2}
        duration={6}
        path="M100,50 A50,50 0 1,1 0,50 A50,50 0 1,1 100,50 Z M100,50"
      />
      <Blob
        className="absolute left-1/4 bottom-16 w-20 h-20 md:w-32 md:h-32"
        colors="#3B82F6"
        delay={0.6}
        duration={8}
        path="M100,15 L130,80 L185,85 L142,125 L155,185 L100,150 L45,185 L58,125 L15,85 L70,80 Z"
      />
      <Blob
        className="absolute right-1/4 bottom-28 w-14 h-14 md:w-24 md:h-24"
        colors="#F43F5E"
        delay={0.9}
        duration={5.5}
        path="M100,170 C40,120 20,80 45,50 C65,25 95,35 100,60 C105,35 135,25 155,50 C180,80 160,120 100,170 Z"
      />
    </div>
  );
}
